import { Pressed, Stack } from 'libs/ui';
import { CSSObject, styled } from 'libs/ui/styled';
import { Colors } from 'libs/ui/theme';

export const ContentStyled = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: 32,
  flexGrow: 1,
  '.clients-sidebar': {
    minWidth: 436,
    maxWidth: 436,
    borderTopRightRadius: 23,
    borderTopLeftRadius: 12,
    backgroundColor: Colors.gray50,
    padding: 16,
  } as CSSObject,

  '.clients-content': {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 24,
    overflow: 'hidden',
    paddingBottom: 32,

    '.header-content, .header-title': {
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      textWrap: 'nowrap',
    },
  } as CSSObject,
}));

export const CloseButtonStyled = styled(Pressed)(() => ({
  textWrap: 'nowrap',
  whiteSpace: 'nowrap',
}));

export const ChangesContentStyled = styled(Stack)(() => ({}));

export const LoadingContentStyled = styled(Stack)(() => ({
  marginTop: 100,
}));
